export const ColorMap = {
  "azul-topazio": { name: "Azul Topázio", hex: "#1e304d" },
  "azul-tita": { name: "Azul Titã", hex: "#1e304d" },
  "branco-lunar": { name: "Branco Lunar", hex: "#e3e3e3" },
  "branco-lunar-e-preto-attitude": {
    name: "Branco Lunar e Preto Attitude",
    hex: "#e3e3e3",
  },
  "branco-polar": { name: "Branco Polar", hex: "#FCFCFC" },
  "branco-perola": { name: "Branco Pérola", hex: "#fff9eb" },
  "cinza-celestial": { name: "Cinza Celestial", hex: "#5f6878" },
  "cinza-granito": { name: "Cinza Granito", hex: "#2b2b2b" },
  "prata-supernova": { name: "Prata Supernova", hex: "#b5b5b5" },
  "prata-lua-nova": { name: "Prata Lua Nova", hex: "#b5b5b5" },
  "prata-nevoa": { name: "Prata Nevoa", hex: "#b5b5b5" },
  preto: { name: "Preto", hex: "#000000" },
  "preto-eclipse": { name: "Preto Eclipse", hex: "#000000" },
  "preto-infinito": { name: "Preto Infinito", hex: "#000000" },
  "preto-attitude": { name: "Preto Attitude", hex: "#000000" },
  "vermelho-granada": { name: "Vermelho Granada", hex: "#870000" },
  "vermelho-volcano": { name: "Vermelho Volcano", hex: "#8c0606" },
  "vermelho-volcano-e-preto-attitude": {
    name: "Vermelho Volcano e Preto Attitude",
    hex: "#8c0606",
  },
  "vermelho-emocao": { name: "Vermelho Emoção", hex: "#870000" },
  "marrom-urban": { name: "Marrom Urban", hex: "#0d0501" },
};

// Depois das definições do ColorMap, exportamos as interfaces e constantes
export interface ColorsProps {
  name: string;
  hex: string;
  images: string[];
  carrossel?: string;
}
export interface VersionProps {
  name: string;
  colors: ColorsProps[];
}
export interface ModelProps {
  name: string;
  versions: VersionProps[];
}
export interface VehicleProps {
  name: string;
  models: ModelProps[];
  internalImages?: string[];
  externalImages?: string[];
}
export const getVehicleDiferentials = (
  vehicle: string,
  model: string,
  version: string
) => {
  switch (vehicle) {
    case "corolla-cross":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "XRE":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 177 cv (E) / 167 cv (G) e 21,4 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro, traseiro e TSS⁴ (Toyota Safety Sense) com controle adaptativo de velocidade de cruzeiro para todas as velocidades, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  'Smart Entry e Push Start, ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital de 12,3", volante com controles de áudio e funções TSS⁴.',
                design:
                  'Rodas de liga leve diamantada 18", faróis em LED, retrovisores externos eletro-retráteis e rebatimento automático. Acabamento interno em couro³ e material sintético, volante em couro preto.',
              };
            case "XR":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 177 cv (E) / 167 cv (G) e 21,4 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro, traseiro e TSS⁴ (Toyota Safety Sense) com controle adaptativo de velocidade de cruzeiro para todas as velocidades, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  'Smart Entry e Push Start, ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital de 12,3", volante com controles de áudio e funções TSS⁴.',
                design:
                  'Rodas de liga leve diamantada 18", faróis em LED, retrovisores externos eletro-retráteis e rebatimento automático. Acabamento interno em couro³ e material sintético, volante em couro preto.',
              };
            case "XRX":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 177 cv (E) / 167 cv (G) e 21,4 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro com suporte à frenagem de estacionamento, e TSS⁴ com controle adaptativo de velocidade de cruzeiro para todas as velocidades, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa.",
                tecnologia:
                  'Smart Entry e Push Start, banco elétrico com 8 ajustes, ar-condicionado digital automático dual zone, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital de 12,3", volante com controles de áudio e funções TSS⁴.',
                design:
                  'Teto solar elétrico com função antiesmagamento, rodas de liga leve tridimensional 18" com acabamento na cor preta, moldura cromada nas janelas, faróis em LED com indicador de direção sequencial, retrovisores externos eletro-retráteis e rebatimento automático. Acabamento interno em couro³ e material sintético bege, volante em couro preto.',
              };
          }
          break;
        case "Híbrido":
          switch (version) {
            case "XRX Híbrido":
              return {
                performance:
                  "Sistema Híbrido Flex com potência de 101 cv (E) / 98 cv (G) no motor a combustão e 72 cv no motor elétrico. Potência combinada de 122 cv. Torque de 14,5 Kgf.m no motor a combustão e 16,6 Kgf.m no elétrico. Transmissão Transaxle CVT.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro com suporte à frenagem de estacionamento, e TSS⁴ com controle adaptativo de velocidade de cruzeiro para todas as velocidades, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa.",
                tecnologia:
                  'Smart Entry e Push Start, banco elétrico com 8 ajustes, ar-condicionado digital automático dual zone, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital de 12,3", volante com controles de áudio e funções TSS⁴.',
                design:
                  'Teto solar elétrico com função antiesmagamento, rodas de liga leve tridimensional 18" com acabamento na cor preta, moldura cromada nas janelas, faróis em LED com indicador de direção sequencial, retrovisores externos eletro-retráteis e rebatimento automático. Acabamento interno em couro³ e material sintético bege, volante em couro preto.',
              };
          }
          break;
        case "Esportivo":
          switch (version) {
            case "GR-Sport":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 177 cv (E) / 169 cv (G) e 21,4 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro, traseiro e alerta de tráfego traseiro, e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa.",
                tecnologia:
                  'Troca de marchas no volante, Smart Entry e Push Start, banco elétrico com 8 ajustes TOYOTA GAZOO Racing, ar-condicionado digital automático dual zone, central multimídia de 8", 9" ou 10" com conexão sem fio Android Auto® e Apple CarPlay®. Painel digital de 7", volante com controles de áudio e funções TSS⁴.',
                design:
                  'Teto solar elétrico com função antiesmagamento, rodas de liga leve 18" e saias esportivas laterais TOYOTA GAZOO Racing. Acabamento interno em couro, material sintético e ultrasuede na cor preta com costuras em vermelho. Placa numerada exclusiva.',
              };
          }
          break;
      }
      break;
    case "corolla":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "GLi":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 175 cv (E) / 167 cv (G) e 21,3 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro e TSS⁴ (Toyota Safety Sense) com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  'Ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital de 7", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Rodas de liga leve 16" e retrovisores externos elétricos na cor do carro com pisca integrado. Acabamento interno em tecido e couro na cor preta e painel central em Black Piano.',
              };
            case "XEi":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 175 cv (E) / 167 cv (G) e 21,3 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  'Smart Entry e Push Start, ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital TFT de 12,3", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Rodas de liga leve 17" e retrovisores externos elétricos na cor do carro com pisca integrado. Acabamento interno em material sintético e couro na cor preta e retrovisor interno com antiofuscamento eletrocrômico, grade frontal em preto brilhante.',
              };
            case "Altis Premium":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 175 cv (E) / 167 cv (G) e 21,3 Kgf.m de torque. Transmissão automática CVT de 10 velocidades.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático, sistema de alerta de mudança de faixa, sensor de ponto cego nos retrovisores externos, reconhecimento de tráfego cruzado traseiro.",
                tecnologia:
                  'Carregador por indução, Smart Entry e Push Start, ar-condicionado digital automático dual zone, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Banco elétrico com 8 ajustes. Painel digital TFT de 12,3", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Faróis em LED, teto solar elétrico com função antiesmagamento, rodas de liga leve 17" na cor preto brilhante. Acabamento interno em material sintético e couro nas cores bege e marrom, retrovisor interno com antiofuscamento eletrocrômico, grade frontal em preto brilhante.',
              };
          }
          break;
        case "Híbrido":
          switch (version) {
            case "Altis Hybrid":
              return {
                performance:
                  "Sistema Híbrido Flex com potência de 101 cv (E) / 98 cv (G) no motor a combustão e 72 cv no motor elétrico. Potência combinada de 122 cv. Torque de 14,5 Kgf.m no motor a combustão e 16,6 Kgf.m no elétrico. Transmissão Transaxle CVT.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  'Smart Entry e Push Start, ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital TFT de 12,3", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Rodas de liga leve 17" e retrovisores externos elétricos na cor do carro com pisca integrado. Acabamento interno em material sintético e couro na cor preta e retrovisor interno com antiofuscamento eletrocrômico, grade frontal em preto brilhante.',
              };
            case "Altis Hybrid Premium":
              return {
                performance:
                  "Sistema Híbrido Flex com potência de 101 cv (E) / 98 cv (G) no motor a combustão e 72 cv no motor elétrico. Potência combinada de 122 cv. Torque de 14,5 Kgf.m no motor a combustão e 16,6 Kgf.m no elétrico. Transmissão Transaxle CVT.",
                seguranca:
                  "7 airbags, sensores de estacionamento dianteiro e traseiro e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático, sistema de alerta de mudança de faixa, sensor de ponto cego nos retrovisores externos, reconhecimento de tráfego cruzado traseiro.",
                tecnologia:
                  'Carregador por indução, Smart Entry e Push Start, ar-condicionado digital automático dual zone, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Banco elétrico com 8 ajustes. Painel digital TFT de 12,3", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Teto solar elétrico com função antiesmagamento, rodas de liga leve 17" na cor preto brilhante, acabamento em Black Piano na grade inferior dianteira e cromado na moldura superior dos vidros. Acabamento interno em couro e material sintético nas cores bege e marrom, grade frontal em preto brilhante.',
              };
          }
          break;
        case "Esportivo":
          switch (version) {
            case "GR-Sport":
              return {
                performance:
                  "Motor de 2.0 L Dual VVT-iE 16 V DOHC Flex com potência de 175 cv (E) / 167 cv (G) e 21,3 Kgf.m de torque. Transmissão automática CVT de 10 velocidades. Conjunto de amortecedores e molas, defletores aerodinâmicos no assoalho e elementos estruturais Toyota Gazoo Racing.",
                seguranca:
                  "7 airbags e TSS⁴ com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático, sistema de alerta de mudança de faixa, sensor de ponto cego nos retrovisores externos, reconhecimento de tráfego cruzado traseiro.",
                tecnologia:
                  'Troca de marchas localizada no volante, Smart Entry e Push Start Toyota Gazoo Racing, ar-condicionado digital automático, central multimídia de 9" com conexão Android Auto® e Apple CarPlay®. Painel digital TFT de 12,3", saída de ar condicionado com duas portas USB-C para passageiros traseiros, volante com controles de áudio e funções TSS⁴.',
                design:
                  'Teto solar elétrico com função antiesmagamento, rodas de liga leve 17" e saias esportivas laterais Toyota Gazoo Racing. Acabamento interno em couro, material sintético e ultrasuede na cor preta com costuras em vermelho. Placa numerada exclusiva.',
              };
          }
          break;
      }
      break;
    case "yaris":
      switch (model) {
        case "Hatch":
          switch (version) {
            case "XL":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL) e assistente de subida.",
                tecnologia:
                  'Central multimídia 7" com 4 alto-falantes e conexão Android Auto® e Apple CarPlay®. Chave com comandos integrados: abertura e travamento das portas e alarme.',
                design:
                  'Faróis halógenos e roda de aço 15" com calota na cor prata. Revestimento em tecido na cor preta nos bancos e portas.',
              };
            case "XS":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL), assistente de subida e TSS⁵ (Toyota Safety Sense) com sistema de pré-colisão e alerta de evasão de faixa.",
                tecnologia:
                  'Central multimídia 7" com 4 alto-falantes, 2 tweeters e conexão Android Auto® e Apple CarPlay®. Smart Entry: sistema de destravamento das portas por sensores nas chaves. Troca de marchas localizada no volante.',
                design:
                  'Faróis halógenos com projetor. Roda de liga leve 15", aerofólio traseiro e acabamento interno do volante e das portas em couro. Bancos com revestimento em couro e tecido.',
              };
            case "XLS":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, faróis de neblina dianteiros, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL), assistente de subida e TSS⁵ (Toyota Safety Sense) com sistema de pré-colisão e alerta de evasão de faixa.",
                tecnologia:
                  'Retrovisor interno com antiofuscamento eletrocrômico e externo com rebatimento elétrico. Troca de marchas no volante. Central multimídia 7" com 4 alto-falantes, 2 tweeters e conexão Android Auto® e Apple CarPlay®.',
                design:
                  'Faróis em LED e teto solar. Rodas de liga leve 15" com acabamento dual tone (preto e cinza). Acabamento interno do volante e portas em couro e bancos com revestimento em couro.',
              };
          }
        case "Sedan":
          switch (version) {
            case "XL":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL) e assistente de subida.",
                tecnologia:
                  'Central multimídia 7" com 4 alto-falantes e conexão Android Auto® e Apple CarPlay®. Chave com comandos integrados: abertura e travamento das portas e alarme.',
                design:
                  'Faróis halógenos e roda de aço 15" com calota na cor prata. Revestimento em tecido na cor preta nos bancos e portas.',
              };
            case "XS":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL), assistente de subida e TSS⁵ (Toyota Safety Sense) com sistema de pré-colisão e alerta de evasão de faixa.",
                tecnologia:
                  'Central multimídia 7" com 4 alto-falantes, 2 tweeters e conexão Android Auto® e Apple CarPlay®. Smart Entry: sistema de destravamento das portas por sensores nas chaves. Troca de marchas localizada no volante.',
                design:
                  'Faróis halógenos com projetor. Roda de liga leve 15", aerofólio traseiro e acabamento interno do volante e das portas em couro. Bancos com revestimento em couro e tecido.',
              };
            case "XLS":
              return {
                performance:
                  "Motor de 1.5 L Dual VVT-i 16 V DOHC Flex 110 cv (E) / 105 cv (G) com transmissão automática CVT de 7 velocidades.",
                seguranca:
                  "7 airbags, faróis de neblina dianteiros, controle eletrônico de estabilidade e de tração, luzes de rodagem diurna (DRL), assistente de subida e TSS⁵ (Toyota Safety Sense) com sistema de pré-colisão e alerta de evasão de faixa.",
                tecnologia:
                  'Retrovisor interno com antiofuscamento eletrocrômico e externo com rebatimento elétrico. Troca de marchas no volante. Central multimídia 7" com 4 alto-falantes, 2 tweeters e conexão Android Auto® e Apple CarPlay®.',
                design:
                  'Faróis em LED e teto solar. Rodas de liga leve 15" com acabamento dual tone (preto e cinza). Acabamento interno do volante e portas em couro e bancos com revestimento em couro.',
              };
          }
      }
      break;
    case "corolla-hatch":
      switch (model) {
        case "Core":
          switch (version) {
            case "Core":
              return {
                performance:
                  "Motor turbo de 1.6L com 3 cilindros, 304cv e 37,7kgfm de torque, acelera de 0 a 100 km/h em 4,9 segundos e tem velocidade máxima de 229 km/h.",
                seguranca:
                  "Equipado com Toyota Safety Sense 3.0 (TSS 3.0), você terá assistência avançada ao dirigir. Pré-colisão, Alerta de Mudança de Faixa, Assistente de Permanência de Faixa, Farol Auto Automático, Controle de Cruzeiro Adaptativo, e Assistente de Sinais de trânsito.",
                tecnologia:
                  "Equipado com o sistema de tração integral GR-FOUR, oferece níveis excepcionais de tração e controle.",
                design:
                  "Câmbio de seis marchas, com ajuste em três diferentes níveis: Eco, Normal e Sport. O GR Corolla possui três saídas de escape funcionais com uma válvula de escape que abre em altas velocidades. Mais potência do motor.",
              };
          }
        case "Circuit":
          switch (version) {
            case "Circuit":
              return {
                performance:
                  "Motor turbo de 1.6L com 3 cilindros, 304cv e 37,7kgfm de torque, acelera de 0 a 100 km/h em 4,9 segundos e tem velocidade máxima de 229 km/h.",
                seguranca:
                  "Equipado com Toyota Safety Sense 3.0 (TSS 3.0), você terá assistência avançada ao dirigir. Pré-colisão, Alerta de Mudança de Faixa, Assistente de Permanência de Faixa, Farol Auto Automático, Controle de Cruzeiro Adaptativo, e Assistente de Sinais de trânsito.",
                tecnologia:
                  "Head-up Display, alerta de ponto-cego e carregador por indução. Equipado com o sistema de tração integral GR-FOUR, oferece níveis excepcionais de tração e controle.",
                design:
                  "Teto em fibra de carbono, câmbio de seis marchas, com ajuste em três diferentes níveis: Eco, Normal e Sport. O GR Corolla possui três saídas de escape funcionais com uma válvula de escape que abre em altas velocidades. Mais potência do motor.",
              };
          }
      }
      break;
    case "sw4":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "SRX":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequencial. Tração 4x4 reduzida com acionamento eletrônico e bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, sistema de alerta de mudança de faixa, assistente de descida e subida, controle adaptativo de velocidade de cruzeiro e assistente de pré-colisão com alerta sonoro e visual e, se necessário, frenagem automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 8 alto-falantes, 2 tweeters e 1 subwoofer (kit JBL) e conexão wireless para Android Auto® e Apple CarPlay®. Câmera 360 graus. Bancos dianteiros ventilados. Volante com comandos integrados de telefone, áudio, funções TSS3 e computador de bordo. Sistema one touch para rebatimento dos bancos traseiros (na versão 7 lugares).',
                design:
                  'Faróis e lanternas de LED. Roda de liga leve 18", aerofólio traseiro, maçanetas internas e externas cromadas e barras longitudinais. Revestimento dos bancos em couro perfurado e material sintético na cor preta.',
              };
            case "SRX Platinum":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequencial. Tração 4x4 reduzida com acionamento eletrônico e bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, sistema de alerta de mudança de faixa, assistente de descida e subida, controle adaptativo de velocidade de cruzeiro e assistente de pré-colisão com alerta sonoro e visual e, se necessário, frenagem automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 8 alto-falantes, 2 tweeters e 1 subwoofer (kit JBL) e conexão wireless para Android Auto® e Apple CarPlay®. Câmera 360 graus. Bancos dianteiros ventilados. Volante com comandos integrados de telefone, áudio, funções TSS3 e computador de bordo. Sistema one touch para rebatimento dos bancos traseiros.',
                design:
                  'Faróis e lanternas de LED. Roda de liga leve 18", aerofólio traseiro, maçanetas internas e externas cromadas e barras longitudinais. Revestimento dos bancos em couro perfurado e material sintético na cor preta.',
              };
            case "Diamond":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico e bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, sistema de alerta de mudança de faixa, assistente de descida e subida, controle adaptativo de velocidade de cruzeiro e assistente de pré-colisão com alerta sonoro e visual e, se necessário, frenagem automática.",
                tecnologia:
                  "Carregador por indução, abertura eletrônica do porta-malas com sensor de presença, saída de ar condicionado central com difusores no teto e controle de intensidade para a terceira fileira.",
                design:
                  'Faróis e lanternas de LED. Roda de liga leve 18", aerofólio traseiro, maçanetas internas e externas cromadas e barras longitudinais. Revestimento dos bancos em couro perfurado e material sintético na cor preta.',
              };
          }
        case "Esportivo":
          switch (version) {
            case "GR-SPORT":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, sistema de alerta de mudança de faixa, assistente de descida e subida, controle adaptativo de velocidade de cruzeiro e assistente de pré-colisão com alerta sonoro e visual e, se necessário, frenagem automática.",
                tecnologia:
                  "Carregador por indução, sistema multimídia de 8 com 8 alto-falantes, 2 tweeters e 1 subwoofer (kit JBL) e conexão com Android Auto® e Apple CarPlay®. Câmera 360 graus. Saída de ar condicionado central com difusores no teto e controle de intensidade para a terceira fileira.",
                design:
                  'Faróis e lanternas de LED. Roda de liga leve 18", aerofólio traseiro, maçanetas internas cromadas e externas na cor do carro, barras longitudinais no teto e para-choques dianteiro e traseiro exclusivo Toyota Gazoo Racing. Revestimento dos bancos em couro, material sintético e suede na cor preta com costuras em vermelho.',
              };
          }
      }
      break;
    case "rav4":
      switch (model) {
        case "Híbrido":
          switch (version) {
            case "SX Connect":
              return {
                performance:
                  "Conjunto híbrido com 3 motores elétricos e motor à combustão de 2.5 L DOHC com potência combinada de 222 cv e transmissão Transaxle CVT de 7 velocidades. AWD (LSD).",
                seguranca:
                  "7 airbags, alerta de ponto cego e TSS (Toyota Safety Sense) com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema de alerta de mudança de faixa com controle de direção.",
                tecnologia:
                  "Aquecimento dos bancos dianteiros, ar-condicionado digital dual zone e abertura e fechamento elétrico da tampa do porta malas por sensor de movimento.",
                design:
                  'Teto solar panorâmico, bancos revestidos em couro e material sintético². Detalhes externos cromados, roda de liga leve 18" e faróis de LED.',
              };
          }
        case "Plug-in":
          switch (version) {
            case "XSE Plug-in":
              return {
                performance:
                  "Conjunto híbrido com 2 motores elétricos e motor à combustão de 2.5 L DOHC com potência combinada de 306 cv e transmissão Transaxle CVT. AWD (LSD).",
                seguranca:
                  "7 airbags, alerta de ponto cego e TSS⁴ (Toyota Safety Sense) com controle adaptativo de velocidade de cruzeiro, assistente de pré-colisão, sistema de alerta de oscilação, farol alto automático e sistema permanência na faixa com controle de direção.",
                tecnologia:
                  'Aquecimento dos bancos dianteiros, ar-condicionado digital dual zone. Head UP display velocidade atual, informações piloto automático e instruções detalhadas de rota.Central Multimidia 10.5". Painel digital 12.3".',
                design:
                  'Bancos revestidos em couro e material sintético². Detalhes externos black piano, roda de liga leve 19" e faróis de LED.',
              };
          }
      }
      break;
    case "hilux":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "STD Power Pack":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 42,8 kgf.m. Transmissão manual de 6 velocidades. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 4 alto-falantes, conexão wireless para Android Auto® e Apple CarPlay®. Acendimento automático dos faróis com temporizador e luz de condução diurna. Volante com comandos integrados de telefone e áudio.',
                design:
                  'Roda de aço estampado 17". Maçanetas e retrovisores externos na cor preta. Console entre os bancos dianteiros com porta-copos, porta-objetos e descansa-braços com acabamento em PVC. Revestimento dos bancos em material sintético.',
              };
            case "STD Power Pack AT":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 4 alto-falantes, conexão wireless para Android Auto® e Apple CarPlay®. Acendimento automático dos faróis com temporizador e luz de condução diurna. Volante com comandos integrados de telefone e áudio.',
                design:
                  'Roda de aço estampado 17". Maçanetas e retrovisores externos na cor preta. Console entre os bancos dianteiros com porta-copos, porta-objetos e descansa-braços com acabamento em PVC. Revestimento dos bancos em material sintético.',
              };
            case "SR":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 4 alto-falantes e 2 tweeters, conexão wireless para Android Auto® e Apple CarPlay®. Ar condicionado digital duas zonas e câmera de ré. Volante com comandos integrados de telefone e áudio, e computador de bordo.',
                design:
                  'Faróis de neblina dianteiros de LED e roda de liga leve 17". Maçanetas externas na cor do veículo e maçanetas internas cromadas. Estribos laterais na cor preta. Console entre os bancos dianteiros com porta-copos, porta-objetos e descansa-braços com acabamento em couro.',
              };
            case "SRV":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  'Sistema multimídia de 9" com 4 alto-falantes e 2 tweeters e conexão wireless para Android Auto® e Apple CarPlay®. Retrovisor interno eletrocrômico. Smart Entry e Push Start.',
                design:
                  'Faróis de neblina dianteiros de LED e roda de liga leve 18". Maçanetas e retrovisores eletrorretráteis externos cromados. Revestimento dos bancos em couro e material sintético⁶. Compartimento refrigerado no painel.',
              };
            case "SRX":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  "Sistema de som JBL com 6 alto-falantes, 2 tweeters e 1 subwoofer. Câmera 360 graus. Bancos dianteiros ventilados. Volante com comandos integrados de telefone, áudio e TSS⁴ (Toyota Safety Sense), e computador de bordo.",
                design:
                  'Faróis e lanternas de LED. Roda de liga leve 18". Capota marítima. Revestimento dos bancos em couro perfurado e material sintético⁶.',
              };
            case "SRX Plus":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 204 cv e torque de 50,9 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, assistente de reboque, assistente de subida, sistema de alarme perimétrico e luz de frenagem emergencial automática.",
                tecnologia:
                  "Sistema de som JBL com 6 alto-falantes, 2 tweeters e 1 subwoofer. Câmera 360 graus. Bancos dianteiros ventilados. Volante com comandos integrados de telefone, áudio e TSS⁴ (Toyota Safety Sense), e computador de bordo.",
                design:
                  'Design com o conceito de Wide Tread. Molduras das caixas de roda exclusivas na cor do veículo. Faróis e lanternas de LED. Roda de liga leve 18" com acabamento aprimorado. Revestimento dos bancos em couro perfurado e material sintético⁶. Capota marítima.',
              };
          }
        case "Esportivo":
          switch (version) {
            case "GR-Sport":
              return {
                performance:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 224 cv e torque de 55,0 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
                seguranca:
                  "7 airbags, sistema de alerta de mudança de faixa, controle de velocidade de cruzeiro adaptativo e assistente de pré-colisão com alerta sonoro e visual e, se necessário, frenagem automática.",
                tecnologia:
                  "Sistema de som JBL com 6 alto-falantes, 2 tweeters e 1 subwoofer. Câmera 360 graus. Volante com comandos integrados de telefone, áudio e TSS⁴ (Toyota Safety Sense), e computador de bordo.",
                design:
                  "Motor 2.8L 16V Turbo movido a diesel S10 com potência de 224 cv e torque de 55,0 kgf.m. Transmissão automática de 6 velocidades sequenciais. Tração 4x4 reduzida com acionamento eletrônico, e com bloqueio do diferencial traseiro.",
              };
          }
      }
      break;
    case "corolla-hatch":
      switch (version) {
        case "Core":
          return {
            motor: "1.6 L Turbo 12V DOHC",
            capacidadeDeCarga: "-",
            transmissao: "Manual 6 marchas",
            tipoDeCombustivel: "Gasolina",
            desempenho: "304 cv / 6.500 rpm",
            audioMultimidia: "Tela sensível ao toque de 7” com espelhamento",
          };
        case "Circuit":
          return {
            motor: "1.6 L Turbo 12V DOHC",
            capacidadeDeCarga: "-",
            transmissao: "Manual 6 marchas",
            tipoDeCombustivel: "Gasolina",
            desempenho: "305 cv / 6.500 rpm",
            audioMultimidia: "Tela sensível ao toque de 7” com espelhamento",
          };
      }
      break;
  }
};

export const getVehicleTech = (
  vehicle: string,
  model: string,
  version: string
) => {
  switch (vehicle) {
    case "corolla-cross":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "XR":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "440L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "177 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
            case "XRE":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "440L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "177 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
            case "XRX":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "440L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "177 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
        case "Híbrido":
          switch (version) {
            case "XRX Híbrido":
              return {
                motor: "1.8L VVT-i 16V DOHC Flex",
                capacidadeDeCarga: "440L",
                transmissao:
                  "Hybrid Transaxle (CVT) + botão seletor: Normal, ECO, Power e EV (Electric Vehicle)",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "101 cv / 5.200 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
        case "Esportivo":
          switch (version) {
            case "GR-Sport":
              return {
                motor: "1.8L VVT-i 16V DOHC Flex",
                capacidadeDeCarga: "440L",
                transmissao:
                  "Hybrid Transaxle (CVT) + botão seletor: Normal, ECO, Power e EV (Electric Vehicle)",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "101 cv / 5.200 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
      }
      break;
    case "corolla":
      switch (model) {
        case "Combustível":
          switch (version) {
            case "GLi":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "175 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
            case "XEI":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades + paddle shift no volante + botão seletor de modo de condução Sport",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "175 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
            case "Altis Premium":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades + paddle shift no volante + botão seletor de modo de condução Sport",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "175 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
        case "Híbrido":
          switch (version) {
            case "Altis Hybrid":
              return {
                motor: "1.8L VVT-i 16V DOHC Flex",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Hybrid Transaxle (CVT) + botão seletor: Normal, ECO, Power e EV (Electric Vehicle)",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "101 cv / 5.200 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
            case "Altis Hybrid Premium":
              return {
                motor: "1.8L VVT-i 16V DOHC Flex",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Hybrid Transaxle (CVT) + botão seletor: Normal, ECO, Power e EV (Electric Vehicle)",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "102 cv / 5.200 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
        case "Esportivo":
          switch (version) {
            case "GR-Sport":
              return {
                motor: "2.0L Dual VVT-iE 16V DOHC Flex (Dynamic Force)",
                capacidadeDeCarga: "470L",
                transmissao:
                  "Direct Shift (CVT) com modo sequencial de dez velocidades + paddle shift no volante + botão seletor de modo de condução Sport",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "175 cv / 6.600 rpm (abastecido 100% com etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 9” com espelhamento",
              };
          }
          break;
      }
      break;
    case "yaris":
      switch (model) {
        case "Hatch":
          switch (version) {
            case "XL":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "110 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
            case "XS":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "111 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
            case "XLS":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "112 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
          }

        case "Sedan":
          switch (version) {
            case "XL":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "110 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
            case "XS":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "111 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
            case "XLS":
              return {
                motor: "1.5L Dual VVT-i",
                capacidadeDeCarga: "310L",
                transmissao:
                  "Multidrive com modo sequencial de sete velocidades",
                tipoDeCombustivel: "Etanol / Gasolina",
                desempenho: "112 cv / 5.600 rpm (etanol)",
                audioMultimidia:
                  "Tela sensível ao toque de 7” com espelhamento",
              };
          }
          break;
      }
      break;
    case "sw4":
      switch (version) {
        case "SRX":
          return {
            motor: "2.8L D-4D16V Turbo intercooler",
            capacidadeDeCarga: "565L",
            transmissao:
              "Automática de 6 velocidades sequencial (com paddle shift)",
            tipoDeCombustivel: "Diesel",
            desempenho: "204 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "SRX Platinum":
          return {
            motor: "2.8L D-4D16V Turbo intercooler",
            capacidadeDeCarga: "565L",
            transmissao:
              "Automática de 6 velocidades sequencial (com paddle shift)",
            tipoDeCombustivel: "Diesel",
            desempenho: "205 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "Diamond":
          return {
            motor: "2.8L D-4D16V Turbo intercooler",
            capacidadeDeCarga: "570L",
            transmissao:
              "Automática de 6 velocidades sequencial (com paddle shift)",
            tipoDeCombustivel: "Diesel",
            desempenho: "206 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "GR-Sport":
          return {
            motor: "2.8L D-4D16V Turbo intercooler",
            capacidadeDeCarga: "565L",
            transmissao:
              "Automática de 6 velocidades sequencial (com paddle shift)",
            tipoDeCombustivel: "Diesel",
            desempenho: "224 cv / 3.000 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
      }
      break;
    case "rav4":
      switch (version) {
        case "SX Connect":
          return {
            motor: "2.5 L DOHC 4 cilindros, 16V (VVT-iE)",
            capacidadeDeCarga: "580L",
            transmissao:
              "HEV Transaxle (com transmissão continuamente variável)",
            tipoDeCombustivel: "Gasolina",
            desempenho: "222 cv",
            audioMultimidia: "Tela sensível ao toque de 10,5” com espelhamento",
          };
        case "XSE Plug-in":
          return {
            motor: "2.5 L DOHC 4 cilindros, 16V (VVT-iE)",
            capacidadeDeCarga: "490L",
            transmissao:
              "HEV Transaxle (com transmissão continuamente variável)",
            tipoDeCombustivel: "Gasolina",
            desempenho: "306 cv",
            audioMultimidia: "Tela sensível ao toque de 10,5” com espelhamento",
          };
      }
      break;
    case "hilux":
      switch (version) {
        case "STD Power Pack":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.000L",
            transmissao: "Manual de 6 velocidades",
            tipoDeCombustivel: "Diesel",
            desempenho: "204 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "STD Power Pack AT":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.000L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "205 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "SR":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.010L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "206 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "SRV":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.005L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "207 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "SRX":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.000L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "208 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "SRX Plus":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.000L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "209 cv / 3.400 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
        case "GR-Sport":
          return {
            motor: "2.8L 16V Turbo Intercooler",
            capacidadeDeCarga: "1.000L",
            transmissao: "Automática de 6 velocidades sequencial",
            tipoDeCombustivel: "Diesel",
            desempenho: "224 cv / 3.000 rpm",
            audioMultimidia: "Tela sensível ao toque de 9” com espelhamento",
          };
      }
      break;
    case "corolla-hatch":
      switch (version) {
        case "Core":
          return {
            motor: "1.6 L Turbo 12V DOHC",
            capacidadeDeCarga: "-",
            transmissao: "Manual 6 marchas",
            tipoDeCombustivel: "Gasolina",
            desempenho: "304 cv / 6.500 rpm",
            audioMultimidia: "Tela sensível ao toque de 7” com espelhamento",
          };
        case "Circuit":
          return {
            motor: "1.6 L Turbo 12V DOHC",
            capacidadeDeCarga: "-",
            transmissao: "Manual 6 marchas",
            tipoDeCombustivel: "Gasolina",
            desempenho: "305 cv / 6.500 rpm",
            audioMultimidia: "Tela sensível ao toque de 7” com espelhamento",
          };
      }
      break;
  }
};
